import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';


let channelLogos =
{
	"Mystery": "images/HMyst-24_LOGO_Black_v2.png",
	"Channel": "images/HC_Logo_New_Black.png",
	"Family": "images/HF_LOGO_Black.png"
}

class OtherProvidersTable extends Component {

	render() {

		return (
			<div className="table-border table">
				<div className="row table-row table-row-grey">
					<div className="col-xs-3">
						<h3 className="table-font other-providers-header">Other Providers</h3>
					</div>
					<div className="col-xs-3">
						<img className="channel-logo" alt={this.props.order[0]} src={channelLogos[this.props.order[0]]} />
					</div>
					<div className="col-xs-3">
						<img className="channel-logo" alt={this.props.order[1]} src={channelLogos[this.props.order[1]]} />
					</div>
					<div className="col-xs-3">
						<img className="channel-logo" alt={this.props.order[2]} src={channelLogos[this.props.order[2]]} />
					</div>
				</div>
				<div className="row table-row">
					<div className="col-xs-3">
						<img className="provider-logo" src="images/DIRECTV_STREAM_2021_logo.png" alt="Direct TV Stream" />
					</div>
					<div className="col-xs-3">
						{this.props.channel === "hd"
							?
							<h3>N/A</h3>
							:
							<FontAwesome className='provider-check' name='check-circle' />
						}
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						{this.props.channel === "hd"
							?
							<h3>N/A</h3>
							:
							<FontAwesome className='provider-check' name='check-circle' />
						}
					</div>
				</div>
				
				<div className="row table-row table-row-grey">
					<div className="col-xs-3">
						<img className="provider-logo" src="images/frndlytv_logo.png" alt="frndlytv" />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
				</div>
				<div className="row table-row">
					<div className="col-xs-3">
						<img className="provider-logo" src="images/logo_fubo.png" alt="Fubo TV" />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
				</div>
				<div className="row table-row table-row-grey">
					<div className="col-xs-3">
						<img className="provider-logo" src="images/hulu-livetv.full.png" alt="Hulu+livetv" />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
				</div>
				{/* <div className="row table-row">
					<div className="col-xs-3">
						<img className="provider-logo" src="images/NBCUniversal_Peacock_Logo.png" alt="Peacock" />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
				</div> */}
				<div className="row table-row">
					<div className="col-xs-3">
						<img className="provider-logo" src="images/philo-logo.png" alt="Philo" />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
				</div>
				<div className="row table-row table-row-grey">
					<div className="col-xs-3">
						<img className="provider-logo" src="images/Sling_TV_logo.svg" alt="Sling TV" />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />

					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
				</div>
				<div className="row table-row">
					<div className="col-xs-3">
						<img className="provider-logo" src="images/YouTube_TV_logo.svg" alt="YouTube TV" />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
					<div className="col-xs-3">
						<FontAwesome className='provider-check' name='check-circle' />
					</div>
				</div>
			</div>
		)
	}
}

export default OtherProvidersTable;


// WEBPACK FOOTER //
// ./src/components/OtherProvidersTable.js